module.exports = __webpack_public_path__ + "img/img21.e9d3e137.jpg";